import React from 'react'

import HeaderWidget from '../../../../../components/atoms/HeaderWidget'
import Loading from '../Loading'

import { useStats } from '../../../../../providers/StatsProvider'

const ClosedToday: React.FC = () => {
  const { chatStats, chatLoaded } = useStats()

  return (
    <HeaderWidget title='Conversations Closed Today'>
      {chatLoaded ? chatStats.closed : <Loading />}
    </HeaderWidget>
  )
}

export default ClosedToday
